// Generate a random 6-character hex color
export const randomHex = () => Math.floor(Math.random() * (0xffffff + 1))
    .toString(16)
    .padStart(6, '0');
